import { PriceStrategy } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { StoreState } from '@/redux/types';
import { getContext } from './getContext';

export const getPriceStrategy = (state: StoreState): PriceStrategy =>
  assertDefined(getContext(state).priceStrategy);
